import map from 'lodash/map'
import React, { useContext, useEffect, useRef, useState } from 'react'

import GuidedFilters from '@Blocks/ProductList/GuidedFilters'
import { ProductTileV2 } from '@Components/ProductList/ProductTiles/LoadMore/ProductTileV2/ProductTileV2'
import { ProductTileWrapperMaxThree } from '@Components/ProductList/ProductTileWrapperMaxThree'
import { ProductTileProps } from '@Domains/Product/Tiles/types'
import { ProductSearchContext } from '@Globals/Algolia/Context'
import { useIntersectingChildrenObserver } from '@Globals/Hooks/IntersectingChildren'
import { GridItemInjections } from '@Globals/Injections/Client'
import { MetadataContext } from '@Globals/Metadata'
import { useTranslation } from '@Globals/Translations'
import { useMediaQuery } from '@Globals/useMediaQuery'

export const ProductTilesIntersectingV2 = ({
  scrollToTop,
}: {
  scrollToTop?: () => void
}) => {
  const { t } = useTranslation()
  const isDesktop = useMediaQuery('(min-width: 1024px)')
  const [enableHover, setEnableHover] = useState(false)
  const { storeURL } = useContext(MetadataContext)
  const wrapperRef = useRef<HTMLDivElement | null>(null)
  const {
    hasActiveFilter,
    hits,
    objectIDs,
    variantsPerHit,
  } = useContext(ProductSearchContext)

  const intersectingChildren = useIntersectingChildrenObserver(
    wrapperRef,
    { attributeName: 'data-intersection-id', rootMargin: '1500px 0px 1500px 0px' },
  )

  useEffect(() => {
    setEnableHover(isDesktop)
  }, [isDesktop])

  const variantsTitle = t('products:COLOURS_LABEL')
  const productTiles = map(objectIDs, (ref) => {
    const tileData = hits?.[ref as string] as unknown as ProductTileProps
    if (!tileData) {
      return null
    }
    return (
      <ProductTileV2
        key={tileData.id}
        bottomChips={tileData.bottomChips}
        brand={tileData.brandTitle}
        bundleCombinedValue={tileData.bundleCombinedValue}
        enableHover={enableHover}
        hoverImage={tileData.hoverImage || undefined}
        intersecting={intersectingChildren[tileData.id] || false}
        originalPrice={tileData.beforePrice || tileData.price}
        overwrittenPrice={tileData.beforePrice ? tileData.price : undefined}
        primaryImage={tileData.primaryImage}
        priority={tileData.priority}
        productID={tileData.id}
        sourceID="product_list"
        title={tileData.title}
        topChips={tileData.topChips}
        url={storeURL(tileData.url)}
        variants={variantsPerHit?.[tileData.id] || 1}
        variantsTitle={variantsTitle}
      />
    )
  })
  return (
    <ProductTileWrapperMaxThree ref={wrapperRef}>
      {productTiles}
      {!hasActiveFilter && <GridItemInjections />}
      <GuidedFilters scrollToTop={scrollToTop} />
    </ProductTileWrapperMaxThree>
  )
}
